import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../../map/mapbox/services/loading.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingInterceptor implements HttpInterceptor {
  private requestsInProgress = 0;

  constructor(public loadingService: LoadingService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requestsInProgress++;
    // Use timeout to put change in next render cycle, which makes no change for user but removes changed after check error
    setTimeout(() => {
      this.loadingService.isLoadingIntercept.next(this.requestsInProgress > 0);
    }, 0);

    return next.handle(req).pipe(
      finalize(() => {
        this.requestsInProgress--;
        setTimeout(() => {
          this.loadingService.isLoadingIntercept.next(
            this.requestsInProgress > 0
          );
        }, 0);
      })
    );
  }
}
